import React, { useEffect } from "react";
import AttendanceDashboardWrapper from "../components/AttendanceWrapper";
import EditDevices from "./components/EditDevices";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const EditDevice = () => {
  const dispatch = useDispatch();
  const router = useNavigate();

  useEffect(() => {
    dispatch({ type: "SIDEBAR", num: "4" });
  }, []);

  const handleSave = (data) => {
    // Logic to add a new device
    router(`/Devices`);
    console.log("Device added:", data);
  };

  return (
    <AttendanceDashboardWrapper>
      <div className="">
        <div className="h-full px-2">
          <div className="flex w-full justify-between">
            <h2 className="text-xl font-semibold">Edit Device</h2>
          </div>
        </div>
        <div>
          <EditDevices onSave={handleSave} onCancel={() => console.log("Add cancelled")} />
        </div>
      </div>
    </AttendanceDashboardWrapper>
  );
};

export default EditDevice;
